module.exports = __webpack_public_path__ + "img/event2412_5_2.568d6ae6.jpg";